module.exports = __webpack_public_path__ + "static/media/trash.2d30e3aa.svg";